module.exports = __webpack_public_path__ + "img/couples-061.27d6f479.jpg";